import script from "./InstructionWepsterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionWepsterPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionWepsterPage.vue?vue&type=style&index=0&id=a437c64a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a437c64a"]])

export default __exports__